import { IPatient, JobStatus } from '../../../..';

type AttributeParts = Pick<
    IPatient,
    | 'hcpId'
    | 'hcpName'
    | 'hcpType'
    | 'hcpGrade'
    | 'madeCurrentDateTime'
    | 'arrivedDateTime'
    | 'finishedDateTime'
    | 'hcpAbortedDateTime'
    | 'abortedBy'
    | 'jobStatus'
    | 'jobStatusBeforeAbort'
    | 'controllerAbortedReason'
    | 'controllerAbortedNotes'
    | 'controllerReverseReason'
    | 'controllerReverseNotes'
    | 'hcpAbortedReason'
    | 'hcpAbortedNotes'
    | 'hcpReverseReason'
    | 'hcpReverseNotes'
    | 'postVisitNotes'
    | 'withdrawnReason'
    | 'withdrawnNotes'
>;

export const getHcpAttributes = (
    patient: Partial<IPatient>,
    options: { isBuddy?: boolean },
): AttributeParts => {
    const {
        abortedBy,
        arrivedDateTime,
        controllerAbortedNotes,
        controllerAbortedReason,
        controllerReverseNotes,
        controllerReverseReason,
        finishedDateTime,
        hcpGrade,
        hcpAbortedDateTime,
        hcpAbortedNotes,
        hcpAbortedReason,
        hcpReverseNotes,
        hcpReverseReason,
        hcpType,
        hcpId,
        jobStatus,
        jobStatusBeforeAbort,
        madeCurrentDateTime,
        hcpName,
        postVisitNotes,
        buddyAbortedBy,
        buddyArrivedDateTime,
        buddyControllerAbortedNotes,
        buddyControllerAbortedReason,
        buddyControllerReverseNotes,
        buddyControllerReverseReason,
        buddyFinishedDateTime,
        buddyGrade,
        buddyHcpAbortedDateTime,
        buddyHcpAbortedNotes,
        buddyHcpAbortedReason,
        buddyHcpReverseNotes,
        buddyHcpReverseReason,
        buddyHcpType,
        buddyId,
        buddyJobStatus,
        buddyJobStatusBeforeAbort,
        buddyMadeCurrentDateTime,
        buddyName,
        postVisitNotesBuddy,
        withdrawnReason,
        withdrawnNotes,
    } = patient;

    const { isBuddy } = options;

    return {
        abortedBy: isBuddy ? buddyAbortedBy : abortedBy,
        arrivedDateTime: isBuddy ? buddyArrivedDateTime : arrivedDateTime,
        controllerAbortedNotes: isBuddy ? buddyControllerAbortedNotes : controllerAbortedNotes,
        controllerAbortedReason: isBuddy ? buddyControllerAbortedReason : controllerAbortedReason,
        controllerReverseNotes: isBuddy ? buddyControllerReverseNotes : controllerReverseNotes,
        controllerReverseReason: isBuddy ? buddyControllerReverseReason : controllerReverseReason,
        finishedDateTime: isBuddy ? buddyFinishedDateTime : finishedDateTime,
        hcpGrade: isBuddy ? buddyGrade : hcpGrade,
        hcpAbortedDateTime: isBuddy ? buddyHcpAbortedDateTime : hcpAbortedDateTime,
        hcpAbortedNotes: isBuddy ? buddyHcpAbortedNotes : hcpAbortedNotes,
        hcpAbortedReason: isBuddy ? buddyHcpAbortedReason : hcpAbortedReason,
        hcpReverseNotes: isBuddy ? buddyHcpReverseNotes : hcpReverseNotes,
        hcpReverseReason: isBuddy ? buddyHcpReverseReason : hcpReverseReason,
        hcpType: isBuddy ? buddyHcpType : hcpType,
        hcpId: isBuddy ? buddyId : hcpId,
        jobStatus: (isBuddy ? buddyJobStatus : jobStatus) || JobStatus.PENDING,
        jobStatusBeforeAbort: isBuddy ? buddyJobStatusBeforeAbort : jobStatusBeforeAbort,
        madeCurrentDateTime: isBuddy ? buddyMadeCurrentDateTime : madeCurrentDateTime,
        hcpName: isBuddy ? buddyName : hcpName,
        postVisitNotes: isBuddy ? postVisitNotesBuddy : postVisitNotes,
        withdrawnReason,
        withdrawnNotes,
    };
};
